import type { TrainingInvoice, TrainingInvoiceListPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTrainingInvoiceList = createApiThunk<PaginatedResult<TrainingInvoice>, TrainingInvoiceListPaginationParams>(
  "trainingInvoices/retrieveTrainingInvoiceList",
  async (params: TrainingInvoiceListPaginationParams, { extra: { adminRepository } }) => {
    return adminRepository!.listTrainingInvoices(params);
  },
);
